// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"488":"2628fab3","611":"fdd00713"}[chunkId] + ".js";
};